import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@klarna/bubble-ui';
import { Themes, useUIThemeContext } from '@klarna/mp-ui';
export function ThemeSelector() {
    const { theme, setTheme } = useUIThemeContext();
    const options = Object.values(Themes).filter(value => value !== Themes.LiquoriceDark);
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { children: "Theme" }), _jsx("select", { style: { height: 30 }, value: theme, onChange: e => setTheme(e.target.value), children: options.map(option => (_jsx("option", { value: option, children: option }, option))) })] }));
}
